import { getCookie } from 'utils';

export const lvl2_default = '74';

const lvl2_map = {
  auto: '8',
  moto: '15',
  utilitaire: '46',
  caravane: '50',
  'camping-car': '50',
};

type Origin = keyof typeof lvl2_map;

export const getLevel2 = (): string | undefined => {
  const origin =
    (getCookie('origin')?.split(/\//).pop() as Origin | undefined) ||
    (localStorage.getItem('depositType')?.toLowerCase() as Origin | undefined);
  return origin && lvl2_map[origin] ? lvl2_map[origin] : lvl2_default;
};
